<template>
  <div class="update-covid-test">
    <div class="form">
      <Datepicker
        :labelName="'Ngày xét nghiệm'"
        :errorMessage="'Vui lòng chọn ngày xét nghiệm'"
        :showError="errorTime"
        :initValue="testTime"
        :disabled="isView"
        @onChange="updateTestTime"
      >
        <img slot="prependIcon" src="/img/icons/calendar.svg" alt="" class="img-calendar"/>
      </Datepicker>

      <Select
        class="mt-4"
        :labelName="'Kết quả xét nghiệm'"
        :errorMessage="error.result.message"
        :showError="error.result.value"
        :initValue="result"
        :disabled="isView"
        :options="[
          { value: 'negative', label: 'Âm tính' },
          { value: 'positive', label: 'Dương tính' },
        ]"
        @onChange="updateResult"
      >
      </Select>

      <Select
        class="mt-4"
        :labelName="'Loại mẫu xét nghiệm'"
        :errorMessage="error.test_type.message"
        :showError="error.test_type.value"
        :initValue="test_type"
        :disabled="isView"
        :options="[
          { value: 'one', label: 'Mẫu đơn' },
          { value: 'pool', label: 'Mẫu gộp' },
        ]"
        @onChange="updateTypeResult"
      >
      </Select>

      <Select
        class="mt-4"
        :labelName="'Kỹ thuật xét nghiệm'"
        :errorMessage="error.test_technique.message"
        :showError="error.test_technique.value"
        :initValue="test_technique"
        :disabled="isView"
        :options="[
          { value: 'PCR', label: 'RT-PCR' },
          { value: 'rapid_test', label: 'Test nhanh' },
        ]"
        @onChange="updateTestTechnique"
      >
      </Select>

      <Select
        class="mt-4"
        :labelName="'Lý do xét nghiệm'"
        :errorMessage="error.reason.message"
        :showError="error.reason.value"
        :initValue="reason"
        :disabled="isView"
        :options="[
          { value: 'urgent_test', label: 'Loại mẫu khẩn cấp' },
          { value: 'routine_test', label: 'Loại mẫu thường quy' },
          { value: 'test_for_move', label: 'Xét nghiệm di chuyển' },
        ]"
        @onChange="updateReason"
      >
      </Select>

      <Select
        class="mt-4"
        :labelName="'Hình thức nhận kết quả'"
        :errorMessage="error.result_type.message"
        :showError="error.result_type.value"
        :initValue="result_type"
        :disabled="isView"
        :options="[
          {
            value: 'e_certificate',
            label: 'Mã QR hoặc Giấy chứng nhận kết quả xét nghiệm điện tử',
          },
          {
            value: 'certitficate',
            label: 'Giấy chứng nhận kết quả xét nghiệm bản cứng',
          },
          { value: 'self-test', label: 'Kết quả trên bộ kit tự test nhanh' },
        ]"
        @onChange="updateResultType"
      >
      </Select>

      <div class="photo mt-4">
        <h3>Ảnh chụp kết quả xét nghiệm</h3>
        <p>Vui lòng chụp lại kết quả xét nghiệm từ Bộ kit tự test nhanh hoặc Mã QR hoặc Giấy xác nhận kết quả xét nghiệm (bản cứng/điện tử)</p>
        <p class="text-error" v-if="errorImage">Vui lòng bổ sung ảnh chụp kết quả xét nghiệm</p>
        <div
          class="review__note__images-tool"
        >
          <div v-if="url === ''"
            class="btn-add-image"
            @click="openImportImage"
          >
            <img src="/img/icons/photo.svg" alt="" />
          </div>
          <div v-else @click="openViewImage">
            <img :src="url" alt="" height="56" width="56" />
          </div>
        </div>
      </div>
    </div>
    <div class="action-absolute">
      <button class="btn-update" :class="{'disabled' : !disabled}" :disabled="!disabled" v-if="!isView"
        @click="createUpdate()">Cập nhật</button>
    </div>
    <PopUpAddImage ref="popUpAddImageRef" @addImage="addImage" />
    <PopUpViewImage :url="url" ref="popUpViewImageRef" />
    <Toast ref="toastRef" :icon="alert" :message="message"/>
  </div>
</template>

<script>
import Datepicker from "@/components/Datetime";
import Select from "@/components/Select";
import Toast from "@/components/Toast";

import PopUpAddImage from "@/modules/covid-test/popupAddImage";
import PopUpViewImage from "@/modules/covid-test/popupViewImage";

import { mapGetters, mapState } from "vuex";

export default {
  name: "CovidInfomation",
  components: {
    Datepicker,
    Select,
    PopUpAddImage,
    PopUpViewImage,
    Toast
  },
  data() {
    return {
      testTime: null,
      result: "",
      test_type: "",
      test_technique: "",
      reason: "",
      result_type: "",
      url: "https://www.pixsy.com/academy/image-user/verify-image-source-copyright-owner/",
      error: {
        testTime: {},
        result: {},
        test_type: {},
        test_technique: {},
        reason: {},
        result_type: {},
      },

      errorTime: false,
      errorImage: false,

      alert: 'Success',
      message: '',
    };
  },
  computed:{
    ...mapState({
      covid_test: state => state.covidTest.covid_test,
    }),
    ...mapGetters(["supplierToken"]),  
    isView(){
      return this.$route.params.id !== 'create'
    },
    disabled(){
      return this.result !== ''  && this.test_type !== '' 
        && this.test_technique !== '' && this.reason !== '' && this.result_type !== '' && !this.isView 
    },
  },
  methods: {
    updateTestTime(value) {
      this.testTime = value
      this.errorTime = false
      this.$forceUpdate()
    },
    updateResult(value) {
      this.result = value
      this.$forceUpdate()
    },
    updateTypeResult(value) {
      this.test_type = value
      this.$forceUpdate()
    },
    updateTestTechnique(value) {
      this.test_technique = value
      this.$forceUpdate()
    },
    updateReason(value){
      this.reason = value
      this.$forceUpdate()
    },
    updateResultType(value){
      this.result_type = value
      this.$forceUpdate()
    },
    openImportImage(){
      if(this.$refs.popUpAddImageRef){
        this.$refs.popUpAddImageRef.show()
      }
    },
    openViewImage(){
      if(this.$refs.popUpViewImageRef){
        this.$refs.popUpViewImageRef.show()
      }
    },
    addImage(value){
      this.url = value.url
      this.errorImage = false
    },
    async createUpdate(){
      if(!this.url && !this.testTime) {
        this.alert = 'Error'
        this.errorImage = true
        this.errorTime = true
        return
      }
      if(!this.url) {
        this.alert = 'Error'
        this.errorImage = true
        return
      }
      if(!this.testTime){
        this.alert = 'Error'
        this.errorTime = true
        return
      }
      const date = new Date(this.testTime);
      const milliseconds = date.getTime(); 
      const data = {
        tested_at: milliseconds/1000,
        result: this.result,
        test_type: this.test_type,
        test_technique: this.test_technique,
        reason: this.reason,
        result_type: this.result_type,
        result_url: this.url,
        token: this.supplierToken
      }

      const response = await this.$store.dispatch('createUpdateCovidTest', data)
      if(response.status === 200) {
        this.$router.push({name : 'covid-test', query: { token: this.supplierToken}})

      }
      else{
        if(this.$refs.toastRef){
          this.$refs.toastRef.show = true
        }
        this.alert = 'Error'
        this.message = response.data.description
      }
    },
    
  },
  created(){
    this.testTime = this.covid_test.tested_at ? new Date(this.covid_test.tested_at*1000) : null
    this.result = this.covid_test.result
    this.test_type = this.covid_test.test_type
    this.test_technique = this.covid_test.test_technique
    this.reason = this.covid_test.reason
    this.result_type = this.covid_test.result_type
    this.url = this.covid_test.result_url
    this.$forceUpdate()
  },
};
</script>

<style lang="scss">
.text-error{
  color: #E8313B !important;
}
.mt-4 {
  margin-top: 10px;
}
.img-calendar{
  padding: 16px;
}
.update-covid-test {
  background-color: #ffffff;
  // height: 100vh;
  position: relative;
  .form {
    background-color: #ffffff;
    padding: 16px;
    max-width: 700px;
    margin: 0 auto;
    .photo {
      h3 {
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        color: #1a1a1a;
      }
      p {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        color: #1a1a1a;
      }
      .review__note__images-tool {
        margin-top: 16px;
        display: flex;
        .btn-add-image{
          width: 56px;
          height: 56px;
          background-color: #F2F3F4;
          border-radius: 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .remove-img{
          width: 18px;
          height: 18px;
          top: -56px;
        }
      }
    }
  }
  .action-absolute {
    // position: absolute;
    width: 100%;
    // bottom: 0;
    // height: 10vh;
    background-color: #ffffff;
    padding: 16px;
    max-width: 700px;
    margin: 0 auto;
    .btn-update {
      background: #ff8200;
      border: 0;
      border-radius: 2px;
      height: 48px;
      margin: 0 auto;
      color: #fff;
      text-transform: none;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      &.disabled{
        background: rgba(0,0,0,.12);
        color: #000;
      }
    }
  }
}


</style>
